module.exports = __webpack_public_path__ + "435ac8618e766a17490f2011fd6d4b57.jpg";